import { render, staticRenderFns } from "./NewAddition.vue?vue&type=template&id=5fe85c8a&scoped=true&"
import script from "./NewAddition.vue?vue&type=script&lang=js&"
export * from "./NewAddition.vue?vue&type=script&lang=js&"
import style0 from "./NewAddition.vue?vue&type=style&index=0&id=5fe85c8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe85c8a",
  null
  
)

export default component.exports